import { IonIcon } from "@ionic/react";
import React, { useContext } from "react";
import styled, { css } from "styled-components";
import { addOutline } from "ionicons/icons";
import WorkspaceContext from "../WorkSpace/WorkspaceContext";
const Container = styled.div`
  margin: 0;
  padding: 0;
  .icon {
    font-size: 20rem;
  }

  span {
    font-size: 2.6rem;
    text-transform: capitalize;
  }
  color: #d97706;
  transition: all 200ms ease-in-out;
  background-color: #e6e6e3;
  border-radius: 1.5rem;
  cursor: pointer;

  &&:hover {
    color: #ffffff;
  }
  ${({ dimensions, canvasScale }) => {
    return css`
      margin: ${20 * canvasScale}px;
      height: ${(dimensions.height - dimensions.header - 40) * canvasScale}px;
    `;
  }}
`;

export default function CanvasAddProductButton({ dimensions }) {
  const { canvasScale, onCreateNewProduct } = useContext(WorkspaceContext);
  return (
    <Container
      canvasScale={canvasScale}
      dimensions={dimensions}
      className="flex direction-column align justify"
      onClick={onCreateNewProduct}
    >
      <IonIcon icon={addOutline} className="icon" />
      <span>Adicionar Produto</span>
    </Container>
  );
}
